/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How often the competition repeats
 * @export
 */
export const RecurrenceSchedule = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    BIWEEKLY: 'BIWEEKLY',
    MONTHLY: 'MONTHLY',
    CUSTOM: 'CUSTOM'
} as const;
export type RecurrenceSchedule = typeof RecurrenceSchedule[keyof typeof RecurrenceSchedule];


export function instanceOfRecurrenceSchedule(value: any): boolean {
    for (const key in RecurrenceSchedule) {
        if (Object.prototype.hasOwnProperty.call(RecurrenceSchedule, key)) {
            if (RecurrenceSchedule[key as keyof typeof RecurrenceSchedule] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RecurrenceScheduleFromJSON(json: any): RecurrenceSchedule {
    return RecurrenceScheduleFromJSONTyped(json, false);
}

export function RecurrenceScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecurrenceSchedule {
    return json as RecurrenceSchedule;
}

export function RecurrenceScheduleToJSON(value?: RecurrenceSchedule | null): any {
    return value as any;
}

export function RecurrenceScheduleToJSONTyped(value: any, ignoreDiscriminator: boolean): RecurrenceSchedule {
    return value as RecurrenceSchedule;
}

